import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class SvgApartments extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e'
    };

    render() {
        const { color, size } = this.props;
        return (
            <svg viewBox="0 0 129.01 265.44" height={size}>
                <rect x="22.96" width="83.08" height="31.45" fill={color} />
                <path
                    d="M214.34,53.55H86.84V287.44h129Zm-97.7,159.91h-6.83v-6.83h6.83Zm0-12.15h-6.83v-6.83h6.83Zm0-17.69h-6.83v-6.84h6.83Zm0-12.16h-6.83v-6.83h6.83Zm0-17.69h-6.83v-6.83h6.83Zm0-12.15h-6.83v-6.83h6.83Zm0-17.69h-6.83V117.1h6.83Zm0-12.16h-6.83V105h6.83Zm0-17.69h-6.83V87.25h6.83Zm0-12.15h-6.83V75.1h6.83ZM129.5,213.46h-6.83v-6.83h6.83Zm0-12.15h-6.83v-6.83h6.83Zm0-17.69h-6.83v-6.84h6.83Zm0-12.16h-6.83v-6.83h6.83Zm0-17.69h-6.83v-6.83h6.83Zm0-12.15h-6.83v-6.83h6.83Zm0-17.69h-6.83V117.1h6.83Zm0-12.16h-6.83V105h6.83Zm0-17.69h-6.83V87.25h6.83Zm0-12.15h-6.83V75.1h6.83Zm18.83,131.53H141.5v-6.83h6.83Zm0-12.15H141.5v-6.83h6.83Zm0-17.69H141.5v-6.84h6.83Zm0-12.16H141.5v-6.83h6.83Zm0-17.69H141.5v-6.83h6.83Zm0-12.15H141.5v-6.83h6.83Zm0-17.69H141.5V117.1h6.83Zm0-12.16H141.5V105h6.83Zm0-17.69H141.5V87.25h6.83Zm0-12.15H141.5V75.1h6.83ZM161.2,213.46h-6.83v-6.83h6.83Zm0-12.15h-6.83v-6.83h6.83Zm0-17.69h-6.83v-6.84h6.83Zm0-12.16h-6.83v-6.83h6.83Zm0-17.69h-6.83v-6.83h6.83Zm0-12.15h-6.83v-6.83h6.83Zm0-17.69h-6.83V117.1h6.83Zm0-12.16h-6.83V105h6.83Zm0-17.69h-6.83V87.25h6.83Zm0-12.15h-6.83V75.1h6.83ZM180,213.46h-6.83v-6.83H180Zm0-12.15h-6.83v-6.83H180Zm0-17.69h-6.83v-6.84H180Zm0-12.16h-6.83v-6.83H180Zm0-17.69h-6.83v-6.83H180Zm0-12.15h-6.83v-6.83H180Zm0-17.69h-6.83V117.1H180Zm0-12.16h-6.83V105H180Zm0-17.69h-6.83V87.25H180Zm0-12.15h-6.83V75.1H180Zm12.87,131.53h-6.83v-6.83h6.83Zm0-12.15h-6.83v-6.83h6.83Zm0-17.69h-6.83v-6.84h6.83Zm0-12.16h-6.83v-6.83h6.83Zm0-17.69h-6.83v-6.83h6.83Zm0-12.15h-6.83v-6.83h6.83Zm0-17.69h-6.83V117.1h6.83Zm0-12.16h-6.83V105h6.83Zm0-17.69h-6.83V87.25h6.83Zm0-12.15h-6.83V75.1h6.83Z"
                    transform="translate(-86.84 -22)"
                    fill={color}
                />
            </svg>
        );
    }
}

export default withTheme(SvgApartments);



// WEBPACK FOOTER //
// ./data/common/iconsvg/SvgApartments.js